module.exports = __webpack_public_path__ + "img/ceo_info_2.d2b4800f.svg";